import React from 'react';

const timeIntervals = [
  { value: '1m', label: '1 Minute' },
  { value: '5m', label: '5 Minutes' },
  { value: '15m', label: '15 Minutes' },
  { value: '30m', label: '30 Minutes' },
  { value: '1h', label: '1 Hour' },
  { value: '4h', label: '4 Hours' },
  { value: '1d', label: '1 Day' },
  { value: '1w', label: '1 Week' },
  { value: '1M', label: '1 Month' }
];

const ChartSettings = ({ settings, onSettingsChange }) => {
  const handleIntervalChange = (event) => {
    onSettingsChange({ ...settings, interval: event.target.value });
  };

  const handleThemeChange = (event) => {
    onSettingsChange({ ...settings, theme: event.target.checked ? 'dark' : 'light' });
  };

  return (
    <div className="flex gap-4 items-center">
      <div className="fieldset">
        <label className="label">
          <span className="text-sm text-xs">Interval</span>
        </label>
        <select
          className="select select select-sm w-32"
          value={settings.interval}
          onChange={handleIntervalChange}
        >
          {timeIntervals.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
      <div className="fieldset">
        <label className="label cursor-pointer gap-2">
          <span className="text-sm text-xs">Dark</span>
          <input
            type="checkbox"
            className="toggle toggle-sm"
            checked={settings.theme === 'dark'}
            onChange={handleThemeChange}
          />
        </label>
      </div>
    </div>
  );
};

export default ChartSettings;
